import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <div className="footer">
      <div className="footerLinks">
        <Link to="/TermsOfService">利用規約</Link>
        <Link to="/AiCommentGuide">AIコメントについて</Link>
        <Link to="/AssetCredits">素材と権利表記</Link>
        <Link to="/Contact">運営への問い合わせ</Link>
      </div>
      <h6 className="footerText">Copyright 2026, UCHI&NIT . All rights reserved.</h6>
    </div>
  );
}

export default Footer;
